import { EnvelopeSimple, Phone, MapPin, Clock } from "@phosphor-icons/react";
import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";
import { SectionLabel } from "@/components/shared/SectionLabel";
import { AnimatedSection } from "@/components/shared/AnimatedSection";
import { CONTACT_INFO } from "@/data/siteData";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1739298061707-cefee19941b7?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

const DETAILS = [
  { icon: Phone, label: "Phone", value: CONTACT_INFO.phone, href: `tel:${CONTACT_INFO.phone.replace(/\s+/g, "")}`, testId: "contact-phone-link" },
  { icon: EnvelopeSimple, label: "Email", value: CONTACT_INFO.email, href: `mailto:${CONTACT_INFO.email}`, testId: "contact-email-link" },
  { icon: MapPin, label: "Office Address", value: CONTACT_INFO.address, testId: "contact-address" },
  { icon: Clock, label: "Working Hours", value: CONTACT_INFO.hours, testId: "contact-hours" },
];

export default function Contact() {
  return (
    <Layout
      title="Contact Us | Mithra Jobs"
      description="Get in touch with Mithra Jobs by phone or email to discuss the teaching positions you are looking to fill."
    >
      <PageHero
        label="Contact Us"
        heading="Let's Talk About Your Recruitment Requirement"
        description="Get in touch with our recruitment team by phone or email to discuss the teaching positions you are looking to fill."
        image={HERO_IMAGE}
        imageAlt="Recruitment team in discussion"
      />

      <section id="enquiry" className="py-24 px-6 bg-cream scroll-mt-24">
        <div className="max-w-3xl mx-auto">
          <SectionLabel>Get in Touch</SectionLabel>
          <div className="grid sm:grid-cols-2 gap-6" data-testid="contact-details-grid">
            {DETAILS.map((item, i) => (
              <AnimatedSection
                key={item.label}
                delay={i * 0.08}
                data-testid={item.testId}
                className="bg-white rounded-2xl border border-navy/10 p-8"
              >
                <item.icon size={26} weight="duotone" className="text-accent mb-5" />
                <p className="text-xs font-semibold uppercase tracking-[0.15em] text-navy/50 mb-2">{item.label}</p>
                {item.href ? (
                  <a href={item.href} className="text-lg font-heading text-navy hover:text-accent transition-colors duration-300">
                    {item.value}
                  </a>
                ) : (
                  <p className="text-navy leading-relaxed">{item.value}</p>
                )}
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
